import speedReading from './views/speedReading/api.js';


export default {
    ...speedReading
}